import React from 'react';
import PropTypes from 'prop-types';
import styles from './SbSharedPagination.scss';
import classnames from 'classnames';
import { Arrow } from '../../components/global/Arrow/Arrow';
import { FormattedMessage } from 'react-intl';
import { getNewPaginationUriRef } from '../../utils/uriUtils';
import { SbSharedLink } from '../SbSharedLink/SbSharedLink';

const SbSharedPaginationArrow = ({ uriRef, isLeft, isRight, currentPage, dataTn, onClick }) => {
    const arrowLinkClasses = classnames(styles.paginationLink, styles.arrowLink, {
        [styles.isLeft]: isLeft,
        [styles.isRight]: isRight,
    });
    let arrowPage;
    let arrow;

    if (isLeft) {
        arrowPage = currentPage - 1;
        arrow = (
            <span>
                <span className={styles.arrow}>
                    <Arrow isLeft />
                </span>
                <FormattedMessage id="sb.SbSharedPagination.previous" defaultMessage="Previous" />
            </span>
        );
    } else if (isRight) {
        arrowPage = currentPage + 1;
        arrow = (
            <span>
                <FormattedMessage id="sb.SbSharedPagination.next" defaultMessage="Next" />
                <span className={styles.arrow}>
                    <Arrow />
                </span>
            </span>
        );
    }

    const newUriRef = getNewPaginationUriRef(uriRef, arrowPage);

    return (
        <li className={`${styles.paginationItem} ${styles.arrowItem}`}>
            <SbSharedLink
                href={newUriRef}
                className={arrowLinkClasses}
                onClick={onClick}
                dataTn={dataTn}
            >
                {arrow}
            </SbSharedLink>
        </li>
    );
};

SbSharedPaginationArrow.defaultProps = {
    onClick: () => {},
};

SbSharedPaginationArrow.propTypes = {
    uriRef: PropTypes.string.isRequired,
    currentPage: PropTypes.number.isRequired,
    isLeft: PropTypes.bool,
    isRight: PropTypes.bool,
    onClick: PropTypes.func,
    dataTn: PropTypes.string,
};

export { SbSharedPaginationArrow };
